export const twoPointFiveDDamageNames = {
  rust: 'Rust',
  blistering: 'Blistering',
  holing: 'Holing',
  cracking: 'Cracking',
  weld: 'Weld Separation',
  lagging: 'Lagging Condition',
  other: 'Other',
} as const

export type KVTwoPointFiveDDamageType = keyof typeof twoPointFiveDDamageNames

export function isTwoPointFiveDDamageType(
  value: string
): value is KVTwoPointFiveDDamageType {
  return Object.hasOwn(twoPointFiveDDamageNames, value)
}

export interface KVTwoPointFiveDAnnotation {
  damageType?: KVTwoPointFiveDDamageType
  damageIndex?: number
  rustGrade?: number
  rustDistribution?: 'S' | 'G' | 'P'
  blisterSize?: number
  blisterDensity?: 'F' | 'M' | 'MD' | 'D'
}
